import type { UserRole } from '../types/auth';
import { useAuth } from '../hooks/useAuth';

const LOGIN_ROLES: UserRole[] = ['admin', 'event_manager', 'scanner', 'viewer'];

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, loginAsRole } = useAuth();

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <section className="auth-shell">
      <div className="auth-card">
        <div className="auth-brand-mark">OU</div>
        <h1>OU Club of Collin County</h1>
        <p className="auth-eyebrow">Admin Portal</p>
        <p className="auth-copy">Use a demo role to review the V2 experience modeled after the live admin site.</p>
        <div className="role-grid">
          {LOGIN_ROLES.map((role) => (
            <button key={role} type="button" className="role-button" onClick={() => loginAsRole(role)}>
              Continue as {role.replace('_', ' ')}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
